<script setup lang="ts">
import PublicHeader from '../components/PublicHeader.vue'
</script>

<template>
  <div class="public-page ocean-bg">
    <PublicHeader />
    <main>
      <section class="hero">
        <div class="hero-copy">
          <p class="eyebrow">A small message with a long way to go</p>
          <h1>Somewhere out there, a kind word is travelling.</h1>
          <p class="hero-lede">
            Each bottle carries a message, a permanent QR code, and a growing trail of human
            moments. If you found one, scan its code to join the journey—anonymously.
          </p>
          <div class="hero-actions">
            <a class="button primary" href="#how-it-works">How the journey works</a>
            <a class="text-link" href="#privacy">Privacy promise →</a>
          </div>
        </div>
        <div
          class="bottle-scene"
          role="img"
          aria-label="A message bottle following a dotted journey"
        >
          <div class="sun"></div>
          <div class="bottle-art" aria-hidden="true">
            <div class="bottle-neck"></div>
            <div class="bottle-body"><span class="paper-roll">Be kind</span></div>
          </div>
          <div class="journey-dots" aria-hidden="true">· · · · · ✦</div>
        </div>
      </section>

      <section id="how-it-works" class="how-section">
        <p class="eyebrow">A three-part adventure</p>
        <h2>Find it. Add your chapter. Send it onward.</h2>
        <div class="step-grid">
          <article>
            <span>01</span>
            <h3>Scan & discover</h3>
            <p>Read the message and see the bottle’s broad, privacy-safe journey.</p>
          </article>
          <article>
            <span>02</span>
            <h3>Leave a note</h3>
            <p>Mark it found and add an anonymous message for the next traveller.</p>
          </article>
          <article>
            <span>03</span>
            <h3>Hide responsibly</h3>
            <p>Choose a safe, discoverable place and help the story continue.</p>
          </article>
        </div>
      </section>

      <section id="privacy" class="privacy-card">
        <div>
          <p class="eyebrow">Privacy by design</p>
          <h2>The journey is remembered. You are not tracked.</h2>
        </div>
        <ul>
          <li>No public accounts or profiles</li>
          <li>No advertising or behavioural analytics</li>
          <li>Exact locations are encrypted and never public</li>
          <li>Temporary, single-use finder permission</li>
        </ul>
      </section>
    </main>
    <footer class="public-footer">
      <span>Message in a Bottle</span><RouterLink to="/admin/login">Administrator</RouterLink>
    </footer>
  </div>
</template>
